import { render, staticRenderFns } from "./GnTab.vue?vue&type=template&id=19a9a9a2&"
import script from "./GnTab.vue?vue&type=script&lang=js&"
export * from "./GnTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports